<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      addShowPower="/shoppayment/add"
    >
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" :isShow="false">
      <el-table-column
        prop="weight"
        label="权重"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="payTypeName"
        label="支付方式"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="payType"
        label="支付类型"
        min-width="120"
        :formatter="formatterTablepayType"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="payTypeCode"
        label="支付类型编码"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="payDesc"
        label="支付方式描述"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0"
            @change="statusturns($event, scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        v-if="hasPerm('/shoppayment/update') || hasPerm('/shoppayment/del')"
        label="操作"
        min-width="260"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            v-if="hasPerm('/shoppayment/update')"
            @click="openAddDialog(scope.row)"
            >修改
          </el-button>
          <el-button
            type="text"
            v-if="hasPerm('/shoppayment/del')"
            @click="handleDelete(scope.row)"
            >删除
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      labelWidth="120px"
      dialogWidth="439px"
    >
      <el-form-item label="权重" prop="weight">
        <el-input-number
          v-model="dialogModel.weight"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="支付方式" prop="payTypeName">
        <el-input
          type="text"
          maxlength="100"
          v-model="dialogModel.payTypeName"
          placeholder="请输入"
          style="width: 180px"
        ></el-input>
      </el-form-item>
      <el-form-item label="支付类型" prop="payType">
        <el-select v-model="dialogModel.payType" style="width: 198px">
          <el-option
            v-for="item in payType"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="支付类型编码" prop="payTypeCode">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.payTypeCode"
          placeholder="请输入"
          style="width: 180px"
        ></el-input>
      </el-form-item>
      <el-form-item label="支付方式描述" prop="payDesc">
        <el-input
          v-model="dialogModel.payDesc"
          maxlength="200"
          show-word-limit
          type="textarea"
          rows="3"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";

import ShopService from "service/ShopService";

import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "shoppayment",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      show: false,
      formModel: {},
      tableData: [],
      payType: [],
      submitService: ShopService.shoppaymentList,
      itemId: "",
      dialogModel: {
        payTypeName: "",
        payType: "",
        payTypeCode: "",
        payDesc: "",
        weight: 0,
      },
      dialogRules: {
        weight: [
          {
            required: true,
            message: "请输入",
          },
        ],
        payTypeCode: [
          {
            required: true,
            message: "请输入",
          },
        ],
        payTypeName: [
          {
            required: true,
            message: "请输入",
          },
        ],
        payType: [
          {
            required: true,
            message: "请选择",
          },
        ],
      },
      isFlag: false,
      currentTypes: {},
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
    this.getTypeNames("payType", (res) => {
      this.payType = [...this.payType, ...res];
    });
  },
  computed: {
    submitData() {
      this.params = {};
      return this.params;
    },
    dialogData() {
      const params = {
        payDesc: this.dialogModel.payDesc,
        payTypeName: this.dialogModel.payTypeName,
        payType: this.dialogModel.payType,
        payTypeCode: this.dialogModel.payTypeCode,
        weight: this.dialogModel.weight,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return this.itemId
        ? ShopService.shoppaymentEdit
        : ShopService.shoppaymentInsert;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
    load() {
      this.formModel = {};
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
          });
        },
        "信息获取失败"
      );
    },
    handleDelete(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        ShopService.shoppaymentDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    statusturns($event, scope) {
      this.doStatus($event, scope);
    },
    doStatus($event, scope) {
      this.doLoad(
        ShopService.shoppaymentStatus,
        {
          id: scope.id,
          status: $event,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    openAddDialog(item, flag) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
      }
      this.$refs.formDialog.open();
    },

    dialogClose() {
      this.dialogModel = {
        payTypeName: "",
        payType: "",
        payTypeCode: "",
        payDesc: "",
        weight: 0,
      };
      this.itemId = "";
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result;
      });
    },
    formatterTablepayType(row, column, cellValue, index) {
      let value = "";
      this.payType.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });

      return value ? value : "--";
    },
  },
};
</script>

<style scoped>
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}
.chenk {
  width: 60px;
  position: relative;
  top: -61px;
  left: 189px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/ShopManagement/ShopPayment.vue